import { union, groupBy, map } from "lodash"
import { traduction } from "Data/traduction"
import { ged_traduction } from "Pages/GED/assets/ged-traduction"
import { getCachedRemoteTranslation } from "./translationLoader"

const localCache = new Map()

export function getAllTrad() {
  // Traduction V1
  const copiedTraduction = JSON.parse(JSON.stringify(traduction))
  // Traduction V2
  const gedTraduction = JSON.parse(JSON.stringify(ged_traduction))
  // Full traduction
  const unionTrad = union(copiedTraduction, gedTraduction)
  const groupByIdTrad = groupBy(unionTrad, "id")
  const allTrad = map(groupByIdTrad, item => Object.assign(...item))
  return allTrad
}

export function getTranslation(langageId) {
  if (langageId && typeof langageId === "object") {
    return langageId
  }

  const remote = getCachedRemoteTranslation(langageId)
  if (remote) return remote

  return getLocalTranslation(langageId)
}

export function getTranslationString(code, langageId) {
  const currentTrad = getTranslation(langageId)
  if (code && currentTrad?.[code]) return currentTrad[code]

  const englishTrad = getTranslation(0)
  if (code && englishTrad?.[code]) return englishTrad[code]

  return undefined
}

export function getTranslationWithTag(trad, tag) {
  if (tag === "orange") {
    const tradSpecOrange = {
      ...trad,
      riskLabelActiviteRisk: trad?.PROCESSUS,
      ACTIVITY: trad?.PROCESSUS,
      SUB_ACTIVITY: trad?.SUB_PROCESSUS,
      ACTIVTY_TAB: trad?.PROCESSUS,
      CREATE_A_ACTIVITY: trad?.CREATE_A_PROCESSUS,
      ADD_ACTIVITY: trad?.ADD_PROCESSUS,
      EDIT_ACTIVITY: trad?.EDIT_PROCESSUS,
      newActivity: trad?.newProcessus,
      addActivity: trad?.addProcessus,
      editActivity: trad?.editProcessus,
      labelActivity1: trad?.labelProcessus1,
      labelActivity2: trad?.labelProcessus2,
      ASSIGN_TO_ACTIVITY: trad?.ASSIGN_TO_PROCESSUS,
      ASSIGN_TO_SUB_ACTIVITY: trad?.ASSIGN_TO_SUB_PROCESSUS,
      DELETE_ACTIVITY: trad?.DELETE_PROCESSUS,
      CONFIRM_DELETE_ACTIVITY: trad?.CONFIRM_DELETE_PROCESSUS,
    }
    return tradSpecOrange
  } else {
    return trad
  }
}

function normalizeLanguageId(langageId) {
  if (typeof langageId === "number" && Number.isFinite(langageId)) return langageId
  if (typeof langageId === "string") {
    const lower = langageId.toLowerCase()
    const localeMap = new Map([
      ["en", 0],
      ["en-us", 0],
      ["en_gb", 0],
      ["fr", 1],
      ["fr-fr", 1],
      ["fr_fr", 1],
      ["de", 2],
      ["de-de", 2],
      ["de_de", 2],
      ["it", 3],
      ["it-it", 3],
      ["es", 4],
      ["es-es", 4],
      ["pt", 5],
      ["pt-pt", 5],
      ["pt-br", 5],
    ])
    if (localeMap.has(lower)) return localeMap.get(lower)
    const parsed = parseInt(lower, 10)
    if (!Number.isNaN(parsed)) return parsed
  }
  return 0
}

function getLocalTranslation(langageId) {
  const normalized = normalizeLanguageId(langageId)
  if (localCache.has(normalized)) {
    return localCache.get(normalized)
  }

  const allTraduction = getAllTrad()
  let trad = allTraduction && allTraduction.filter(i => i.id === normalized)
  if (!trad || trad.length === 0) {
    trad = allTraduction && allTraduction.filter(i => i.id === 0)
  }
  const result = trad?.[0]
  if (result) {
    localCache.set(normalized, result)
  }
  return result
}
